// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"24":"37bcc4aa","58":"41cfca8b","260":"63399625","339":"4f16a6f4","443":"dccccb14","507":"50d85ec6","660":"d4454ef8","679":"444ad8cf","775":"083b049d","785":"d2f245d7","814":"3fe47acd","936":"4c8b5111"}[chunkId] + ".js";
};